import type { TranslationMessages } from './types';

export const faq: TranslationMessages = {
  title: 'Câu hỏi thường gặp',
  description: 'Một số câu hỏi thường gặp khi sử dụng NEKO POS.',
  howToReportBug: {
    question: 'Làm thế nào để báo cáo lỗi?',
    answer:
      'Nhấn nút "Hỗ trợ" ở thanh trên cùng, chọn "Báo cáo lỗi", sau đó mô tả vấn đề và (nếu có thể) đính kèm ảnh chụp màn hình. Thông tin chi tiết sẽ được gửi tới đội hỗ trợ.',
  },
  howToRequestFeature: {
    question: 'Làm thế nào để đề xuất tính năng mới?',
    answer:
      'Bạn có thể gửi yêu cầu thông qua account manager của cửa hàng hoặc ghi rõ đề xuất của mình trong phần báo cáo lỗi. Hãy mô tả cụ thể quy trình làm việc và kết quả bạn mong muốn.',
  },
  urgentSupport: {
    question: 'Nếu hệ thống POS bị lỗi nặng hoặc cần hỗ trợ gấp thì làm gì?',
    answer:
      'Hãy làm theo quy trình eskalation của cửa hàng (gọi điện/Chat/Slack) để liên hệ đội hỗ trợ NEKO. Vui lòng cung cấp tên cửa hàng, vấn đề gặp phải và các mã đơn liên quan (nếu có) để được hỗ trợ nhanh hơn.',
  },
};
